export default "__VITE_ASSET__Bqi8sHI6__"